import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Messages } from '../../../constants/messages.constants';
import { Claim } from '@lsq-frontend/remote-services/enterprise/common';
import { ClaimService } from '../../../services/claim/claim.service';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';

@Injectable()
export class ClaimGuard implements CanActivate {
    constructor(
        private _claimService: ClaimService,
        private _alertService: AlertService,
        private _router: Router
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        if (!route.data.claims || !route.data.claims.length) {
            // This is an edge case; any route with a ClaimGuard should have `data.claims`.
            throw new Error(
                `Route ${state.url} is guarded with a ClaimGuard, so expected to find ` +
                    `claims in 'data.claims'; instead, got ${route.data.claims}`
            );
        }

        if (route.data.claims && route.data.claims.length) {
            return combineLatest([
                ...(route.data.claims as Claim[]).map((claim) => this._claimService.isOn(claim))
            ]).pipe(
                map((claimsAreOn) => claimsAreOn.some((claimIsOn) => claimIsOn)),
                tap(
                    (canActivate) =>
                        !canActivate && this._alertService.error(Messages.NavigationForbidden)
                ),
                map((canActivate) => canActivate || this._router.parseUrl(`/${UiRoutes.NotFound}`))
            );
        }
    }
}
